import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import BlogCommentTable from "./Components/BlogCommentTable";

const BlogCommentList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={<HeadingOne>Blog Comments</HeadingOne>}
        >
            <div className="col-12">
                <BlogCommentTable />
            </div>
        </PageBody>
    );
};

export default BlogCommentList;
